import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTruck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m27.937 12.797-1.532-3.828a1.742 1.742 0 0 0-1.623-1.094H21V7a.875.875 0 0 0-.875-.875H3.5a1.75 1.75 0 0 0-1.75 1.75v12.25a1.75 1.75 0 0 0 1.75 1.75h1.86a3.5 3.5 0 0 0 6.78 0h5.47a3.5 3.5 0 0 0 6.78 0h1.86a1.75 1.75 0 0 0 1.75-1.75v-7a.868.868 0 0 0-.063-.328ZM21 9.625h3.782l1.05 2.625H21V9.625ZM3.5 7.875h15.75v7H3.5v-7ZM8.75 22.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Zm8.86-2.625h-5.47a3.5 3.5 0 0 0-6.78 0H3.5v-3.5h15.75v1.346a3.513 3.513 0 0 0-1.64 2.154ZM21 22.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Zm5.25-2.625h-1.86A3.507 3.507 0 0 0 21 17.5V14h5.25v6.125Z" />
  </svg>
);
export default SvgTruck;
